import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IVisitSalesItemRequirementsValidationResultModel
  extends ISyncModel {
  visitSalesItemId: number;
  deepLinkedSalesSubCategoryId?: number;
  deepLinkedSalesCategoryId?: number;
  deepLinkedSalesSubCategoryDisplayName?: string;
}

export class VisitSalesItemRequirementsValidationResultModel
  extends SyncModel
  implements IVisitSalesItemRequirementsValidationResultModel
{
  visitSalesItemId: number;
  deepLinkedSalesSubCategoryId?: number | undefined;
  deepLinkedSalesCategoryId?: number | undefined;
  deepLinkedSalesSubCategoryDisplayName?: string | undefined;
  constructor(params: IVisitSalesItemRequirementsValidationResultModel) {
    super(params);
    this.visitSalesItemId = _.defaultTo(params.visitSalesItemId, 0);
    this.deepLinkedSalesSubCategoryId = _.defaultTo(
      params.deepLinkedSalesSubCategoryId,
      undefined,
    );
    this.deepLinkedSalesCategoryId = _.defaultTo(
      params.deepLinkedSalesCategoryId,
      undefined,
    );
    this.deepLinkedSalesSubCategoryDisplayName = _.defaultTo(
      params.deepLinkedSalesSubCategoryDisplayName,
      '',
    );
  }
}
